import React, { createContext, useCallback, useContext, useState } from 'react';
import { IUserBase } from '../models/users';
import { IDetailedAppointment } from '../services/Appointments/ShowAppointmentsService';
import { maskDateTime, maskMoney } from '../utils/formatters/handleMask';

export interface IAppointmentContextState extends IDetailedAppointment {
  formattedCreatedAt: string;
  formattedTotalValue: string;
  titularUser: IUserBase;
}

interface IHandleAppointment extends IDetailedAppointment {
  titularUser: IUserBase;
}

interface IAppointmentContextData {
  appointment?: IAppointmentContextState;
  handleAppointment: (appointment?: IHandleAppointment) => void;
}

const AppointmentContext = createContext<IAppointmentContextData>(
  {} as IAppointmentContextData,
);

const AppointmentProvider: React.FC = ({ children }) => {
  const [appointment, setAppointment] = useState<IAppointmentContextState>();

  const handleAppointment = useCallback(
    (appointmentData?: IHandleAppointment) => {
      if (appointmentData) {
        setAppointment({
          ...appointmentData,
          formattedCreatedAt: maskDateTime(appointmentData.createdAt),
          formattedTotalValue: maskMoney(appointmentData.totalValue),
        });
      } else {
        setAppointment(undefined);
      }
    },
    [],
  );

  return (
    <AppointmentContext.Provider
      value={{
        appointment,
        handleAppointment,
      }}
    >
      {children}
    </AppointmentContext.Provider>
  );
};

const useAppointment = (): IAppointmentContextData =>
  useContext(AppointmentContext);

export { AppointmentProvider, useAppointment };
